import { motion } from "framer-motion";
import { useShop } from "../context/ShopContext";
import { formatPrice } from "../lib/constants";

export const PerfumeCard = ({ p, index = 0 }) => {
  const { openPerfume, collections } = useShop();
  const col = collections.find((c) => (p.collections || []).includes(c.slug));

  return (
    <motion.button
      data-testid={`perfume-card-${p.slug}`}
      onClick={() => openPerfume(p)}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 0.8, delay: (index % 4) * 0.08, ease: [0.22, 1, 0.36, 1] }}
      className="group text-left"
    >
      <div className="relative aspect-[3/4] overflow-hidden rounded-xl bg-sand">
        {p.image_url ? (
          <img
            src={p.image_url}
            alt={p.name}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-[1200ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.05]"
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center font-serif text-6xl text-taupe/40">V</div>
        )}
        {p.featured && (
          <span className="absolute left-4 top-4 rounded-full bg-ivory/90 px-3 py-1.5 text-[9px] uppercase tracking-[0.25em] text-espresso backdrop-blur">
            Coup de cœur
          </span>
        )}
        <div className="absolute inset-x-4 bottom-4 flex translate-y-3 justify-center opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100">
          <span className="rounded-full bg-espresso px-6 py-3 text-[10px] uppercase tracking-[0.25em] text-ivory">Découvrir</span>
        </div>
      </div>
      <div className="mt-4 flex items-start justify-between gap-3">
        <div>
          <h3 className="font-serif text-xl leading-tight text-espresso sm:text-2xl">{p.name}</h3>
          <p className="mt-1.5 text-[10px] uppercase tracking-[0.25em] text-taupe">{col?.short || col?.name || ""}</p>
        </div>
        <p className="whitespace-nowrap font-serif text-lg text-espresso">{formatPrice(p.price)}</p>
      </div>
    </motion.button>
  );
};
